"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketConnection = void 0;
const isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
const strongly_typed_events_1 = require("strongly-typed-events");
const RTMessage_1 = require("./RTMessage");
const Packet_pb_1 = require("../proto/Packet_pb");
const utils_1 = require("../utils");
const messages_1 = require("../messages");
const types_1 = require("@repo/types");
class WebSocketConnection {
    tlsEnabled;
    webSocket;
    connectionOpen = new strongly_typed_events_1.SimpleEventDispatcher();
    connectionClose = new strongly_typed_events_1.SimpleEventDispatcher();
    connectionError = new strongly_typed_events_1.SimpleEventDispatcher();
    messageReceived = new strongly_typed_events_1.SimpleEventDispatcher();
    constructor(tlsEnabled) {
        this.tlsEnabled = tlsEnabled;
    }
    initializeWebSocket(uri) {
        this.webSocket = this.createWebSocket(uri);
        this.webSocket.onopen = this.webSocket_Opened;
        this.webSocket.onclose = this.webSocket_Closed;
        this.webSocket.onerror = this.webSocket_Error;
        this.webSocket.onmessage = this.webSocket_MessageReceived;
    }
    createWebSocket(uri) {
        return new isomorphic_ws_1.default(uri);
    }
    close() {
        this.webSocket?.close();
    }
    send(packet) {
        if (!this.webSocket)
            return;
        const buffer = packet.serializeBinary();
        // add a header indicating the size of the data
        const sizeVarIntBytes = (0, utils_1.toVarInt)(buffer.length);
        const packagedData = new Uint8Array(sizeVarIntBytes.length + buffer.length);
        packagedData.set(sizeVarIntBytes);
        packagedData.set(buffer, sizeVarIntBytes.length);
        return this.webSocket.send(packagedData);
    }
    webSocket_Opened = (event) => {
        this.connectionOpen.dispatch(event);
    };
    webSocket_Closed = (event) => {
        this.connectionClose.dispatch(event);
    };
    webSocket_Error = (event) => {
        console.error(event);
        this.connectionError.dispatch(event);
    };
    webSocket_MessageReceived = async (event) => {
        const eventData = event;
        const buffer = eventData.data instanceof Blob ? new Uint8Array(await eventData.data.arrayBuffer()) : Uint8Array.from(eventData.data);
        let sizeFieldLen = 0;
        while (sizeFieldLen < buffer.length && buffer[sizeFieldLen] !== undefined && buffer[sizeFieldLen] >= 128) {
            sizeFieldLen++;
        }
        const data = buffer.slice(sizeFieldLen + 1);
        const packet = Packet_pb_1.Packet.deserializeBinary(data);
        const message = RTMessage_1.RTMessage.fromPacket(packet);
        if (message.opCode !== types_1.OP_CODE.LOGIN_RESULT) {
            this.messageReceived.dispatch(message);
            return;
        }
        const loginResult = packet.getLoginresult();
        this.messageReceived.dispatch(new messages_1.LoginResult(packet.getTargetplayer(), loginResult.getSuccess(), loginResult.getConnecttoken(), loginResult.getReconnecttoken()));
    };
}
exports.WebSocketConnection = WebSocketConnection;
